module.exports = "<p>cancellation works!</p>\n"